module.exports = __webpack_public_path__ + "img/tc.fea686c4.png";